import React, { useEffect, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import { Autocomplete, Box, Button, FormControl, Grid, IconButton, Paper, TextField } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import Title from '../../../components/Title';
import { DataGrid } from '@material-ui/data-grid';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import Message from '../../tools/Message';
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from '@mui/icons-material/Search';
import Spacer from '../../../components/Spacer';
import { useNavigate } from 'react-router';
import DownloadIcon from '@mui/icons-material/Download';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
}));

const TimesheetLogistic = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [filter, setFilter] = useState({
        reference: '',
        vehicle: '',
        driver: '',
    });
    const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
    });
    const { open, color, messageInfo } = message;

     function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

    useEffect(() => {
        const fetchData = async () => {
            setOpenLoadingSimpleBackdrop(true);
            try {
                const response = await ProvisionalFuelMissionService.getTimesheetsVehicleList();
                if(response.status){
                    const data = response.data.map((item, index) => ({
                        ...item,
                        id: index + 1,
                    }));
                    setRows(data);
                    setOpenLoadingSimpleBackdrop(false);
                    setMessage({
                        open: true,
                        color: 'green',
                        messageInfo: 'Données du timesheet récupérées avec succès.',
                    });
                }
            } catch (error) {
                console.error('Error fetching timesheet data:', error);
                setOpenLoadingSimpleBackdrop(false);
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: 'Erreur lors de la récupération des données du timesheet.',
                });
            }
        };

        fetchData();
    }, []);

    const handleDownloadTimesheet = async (transportId, missionTimesheetId) => {
        try {
            const response = await ProvisionalFuelMissionService.generateTimesheetVehicle(transportId, missionTimesheetId);
            if (response.status) {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `timesheet_${transportId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: response.message || 'Erreur lors du téléchargement du timesheet.',
                });
            }
        } catch (error) {
            console.error('Error downloading timesheet:', error);
            setMessage({
                open: true,
                color: 'red',
                messageInfo: 'Erreur lors du téléchargement du timesheet.',
            });
        }
    };

    const columns = [
       {
        field: 'vhc_imm',
        headerName: 'Voiture',
        width: 160,
        renderCell: (params) => (
            <span>{params.value} - {params.row.vhc_type}</span>
        ),
        },
        { field: 'direction_code', headerName: 'Direction voiture', width: 100 },
        { field: 'driver_name', headerName: 'Chauffeur', width: 200 },
        { field: 'mission_references', headerName: 'Mission(s)', width: 240 },
        { field: 'destinations', headerName: 'Destination(s)', width: 200 },
        { field: 'date_debut', headerName: 'Date de debut', width: 180, renderCell: (params) => (
            <span>{new Date(params.value).toLocaleDateString()}</span>
            )},
        { field: 'date_fin', headerName: 'Date de fin', width: 150, renderCell: (params) => (
            <span>{new Date(params.value).toLocaleDateString()}</span>
            )},

        { field: 'action', headerName: 'Action', width: 100, renderCell: (params) => (
            <>
                {/* <IconButton title='Modifier le timesheet'
                onClick={() => { navigate(`/logistic/mission/timesheet/${params.row.transport_id}`)}}
                color="primary"
                >
                    <EditIcon/>
                </IconButton> */}
                <IconButton color='success' title='Télécharger le timesheet'
                onClick={() => params.row.mission_timesheet_id	 ? handleDownloadTimesheet(params.row.transport_id, params.row.mission_timesheet_id	) : navigate(`/logistic/mission/timesheet/${params.row.transport_id}`)}>
                  <DownloadForOfflineIcon />
                </IconButton>
            </>
        )
        },
    ];

    return (
        <MainContainer {...headerDataImmo}>
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} /> 
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
          <Box display="flex" justifyContent="flex-end" alignItems="right">
        <Grid container xs={12} sm={6} md={3} spacing={4} justifyContent={"flex-end"} my={2}>
          <Button
            variant="contained"
            color="primary"
            // onClick={handleFilter}
            className={classes.btn}
          >
            <SearchIcon style={{ marginRight: '8px' }} />
            Filtrer
          </Button>
          <Spacer x={1} />
        </Grid>
        
      </Box>

       <Grid container xs={12} spacing={2} >
           <Grid item xs={12} sm={6} md={3}>
          <label className={classes.labelPosition}>Réference:</label>
          <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete
                  id="tags-outlined"
                  options={[]}
                  sx={{
                    '& .MuiInputBase-root': { height: 40 }, 
                    '& .MuiInputBase-input': { padding: '4px 8px' } 
                  }}
                  getOptionLabel={(option) =>
                    `${option}`
                  }
                  filterSelectedOptions
                //   onChange={(event, newValue) => {
                //     setFilter({ ...filter, reference: newValue });
                //   }
                //   }
                  size='small'
                //   value={filter.reference}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
          </FormControl>
        </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <label className={classes.labelPosition}>Voiture:</label>
          <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete
                  id="tags-outlined"
                  options={[]}
                  sx={{
                    '& .MuiInputBase-root': { height: 40 }, 
                    '& .MuiInputBase-input': { padding: '4px 8px' } 
                  }}
                  getOptionLabel={(option) =>
                    `${option}`
                  }
                  filterSelectedOptions
                //   onChange={(event, newValue) => {
                //     setFilter({ ...filter, reference: newValue });
                //   }
                //   }
                  size='small'
                //   value={filter.reference}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
          </FormControl>
        </Grid>
          <Grid item xs={12} sm={6} md={3}>
          <label className={classes.labelPosition}>Chauffeur:</label>
          <FormControl fullWidth variant="outlined" size="small">
              <Autocomplete
                  id="tags-outlined"
                  options={[]}
                  sx={{
                    '& .MuiInputBase-root': { height: 40 }, 
                    '& .MuiInputBase-input': { padding: '4px 8px' } 
                  }}
                  getOptionLabel={(option) =>
                    `${option}`
                  }
                  filterSelectedOptions
                //   onChange={(event, newValue) => {
                //     setFilter({ ...filter, reference: newValue });
                //   }
                //   }
                  size='small'
                //   value={filter.reference}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" size="small" />
                  )}
                />
          </FormControl>
        </Grid>
        </Grid>
                  <Paper className={classes.paper} variant="outlined">
                    <Title>Décompte de carburant  prévisionnel par voiture</Title>
        <div style={{ height: 800, width: '100%' }}>
                    <DataGrid rows={rows} columns={columns}
                              pageSize={10}
                              rowsPerPageOptions={[10, 20, 50]}
                              pagination
                              paginationMode="server"
                              disableSelectionOnClick />
        </div>
            </Paper>
        </MainContainer>
    );
    }
export default TimesheetLogistic;